module.exports = __webpack_public_path__ + "static/media/assign grade coordinator.791e1661.svg";